import {combineReducers, createStore, applyMiddleware, compose} from 'redux';
import {routerReducer, routerMiddleware} from 'react-router-redux';
import thunk from 'redux-thunk';
import {setup, actionwareReducer} from 'actionware';

import history from '../features/history/index';
import identity, {getInitialState as getIdentityState} from './identity';
import customers from './customers';

const rootReducer = {
  identity,
  customers,
  actionwareReducer,
  router: routerReducer,
};

const historyMiddleware = routerMiddleware(history);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  combineReducers(rootReducer),
  {
    identity: getIdentityState(),
  },
  composeEnhancers(applyMiddleware(historyMiddleware, thunk))
);

setup({store});

export default store;
